import { useState } from "react";
import { useNavigate } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import styles from "./ForgotPasswordPage.module.css";
import bgImage from "../../assets/images/bg-login.jpeg";
import api from "../../services/api";
import { ENDPOINTS } from "../../utils/endpoints";
import { toast } from "react-toastify";

const ForgotPasswordPage = () => {
  const [formData, setFormData] = useState({
    email: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (field) => (e) =>
    setFormData({ ...formData, [field]: e.target.value });

  const handleSendOtp = async () => {
    setError("");
    setLoading(true);

    try {
      const { data } = await api.post(ENDPOINTS.RESET_PASSWORD, formData);
      if (data.success) {
        toast.success(data.message);
        navigate("/");
      } else {
        toast.error(data.message || "Please try after sometime");
        setError(data.message || "Please try after sometime");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong");
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      {loading && <div className={styles.loadingOverlay}>Please wait...</div>}

      <div className={styles.left}>
        <img src={bgImage} alt="signup-bg" className={styles.bgImage} />
        {/* <div className={styles.logo}>EAU</div> */}
        {/* <p className={styles.subTitle}>Ecolearn & Alpha Universe Group</p> */}
      </div>

      <div className={styles.right}>
        <h2 className={styles.title}>RESET PASSWORD</h2>

        <InputField
          icon={<EmailIcon className={styles.icon} />}
          placeholder="Email"
          value={formData.email}
          onChange={handleChange("email")}
        />

        <button
          className={styles.loginBtn}
          onClick={handleSendOtp}
          disabled={loading}
        >
          {loading ? "Sending reset mail..." : "Send reset mail"}
        </button>

        {error && <p className={styles.error}>{error}</p>}

        <p className={styles.signup} onClick={() => navigate("/")}>
          Back to Login
        </p>
      </div>
    </div>
  );
};

const InputField = ({ icon, placeholder, type = "text", value, onChange }) => (
  <div className={styles.inputGroup}>
    {icon && icon}
    <input
      type={type}
      placeholder={placeholder}
      className={styles.input}
      value={value}
      onChange={onChange}
    />
  </div>
);

export default ForgotPasswordPage;
